<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'10px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="账号" name='level'>
          <a-input v-model:value="search.account" placeholder='请输入操作用户账号' />
        </a-form-item>
        <a-form-item label="操作时间" >
          <a-range-picker  @change="onChange" v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click='pageSearchReset'>重置</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='account' :columns='columns' :data-source='data'>
      </a-table>
      <a-pagination size="small" :style="{marginTop:'20px',textAlign:'right'}" :current="search.page" :page-size="search.limit" :total="total" show-size-changer show-quick-jumper @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted, inject } from "vue";
import { iscode } from "@/utils/app";
import  {getLogs,getAdmin}  from '@/api/system'
// 初始化默认筛选项数值
let defSearch = {
  account:'',
  page: 1,
  limit: 10,
  start: '',
  end: ''
};
export default {
  setup(props) {
    // // 初始化 分页信息和筛选项信息
    const _lodash = inject("_lodash");
    let total = ref(1);
    let search = ref(_lodash.cloneDeep({ ...defSearch }));
    // 列表数据和列头配置
    let data = ref();
    let time = ref([])
    let listLoading = ref(false);
    let columns = [
      {
        title: "操作用户",
        dataIndex: "username",
        key: "username",
      },
      {
        title: "账号",
        dataIndex: "account",
        key: "account",
      },
      //  {
      //   title: "接口方法",
      //   dataIndex: "method",
      //   key: "method",
      // },
      {
        title: "IP",
        dataIndex: "ip",
        key: "ip",
      },
      {
        title: "操作时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作内容",
        dataIndex: "title",
        key: "title",
      },
    ];
    
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 页面筛选项重置
    const pageSearchReset = () => {
      search.value = {
        ...defSearch,
        page: search.value.page,
        limit: search.value.limit,
      };
      time.value = []
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 切换时间
    const onChange = (e) => {
      search.value.start=e[0]
      search.value.end=e[1]
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const initData = async (values) => {
      listLoading.value = true;
        let res = await getLogs(values).then(res=>res.data).catch(error=>error);
        listLoading.value = false;
        if (iscode(res)) {
          data.value = res.data.data;
          total.value = res.data.total;
        } 
    };
    const action = (e) => {
      console.log(e);
    };
    onMounted(() => {
      initData(search.value);
    });
    return {
      total,
      search,
      data,
      time,
      listLoading,
      columns,
      pageSearchChange,
      pageSearchReset,
      pageCurrentChange,
      pageSizeChange,
      action,
      onChange
    };
  },
};
</script>